import React from 'react';

import { withAuth } from '@/components/with_auth';

import ContactsGamePanel from '@/components/my-sixty/contacts-game';

function ContactsGame() {
    return (
        <ContactsGamePanel showHeader={false} />
    );
}

export default withAuth(ContactsGame);
